import { defineComponent as _defineComponent } from 'vue';
import Menu from 'primevue/menu';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import { defineAsyncComponent, ref, watchEffect } from 'vue';
import { usePageProps } from '../../Plugins/page-props';
import { useMitt } from '../../Plugins/mitt';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CompanyAddActionsButton',
    setup(__props, { expose }) {
        expose();
        const UserForm = defineAsyncComponent(() => import('../Company/UserDetails.vue'));
        const OrchardForm = defineAsyncComponent(() => import('@/Pages/Orchard/OrchardDetailsForm.vue'));
        const DevicesForm = defineAsyncComponent(() => import('@/Pages/Orchard/Devices/EditCreate.vue'));
        const FertilizationsForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Fertilizations/EditCreate.vue'));
        const IrrigationsForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/Irrigations/EditCreate.vue'));
        const PlotForm = defineAsyncComponent(() => import('@/Pages/Orchard/Plots/EditCreate.vue'));
        const emitter = useMitt();
        const pageProps = usePageProps();
        const company = pageProps.company();
        const menu = ref();
        const selectedForm = ref();
        const forms = [
            {
                label: 'Nuovo Utente',
                component: UserForm,
            },
            {
                label: 'Nuovo Impianto',
                component: OrchardForm,
            },
            {
                label: 'Nuovo Lotto',
                component: PlotForm,
            },
            // {
            //   label: 'Nuovo Dispositivo',
            //   component: DevicesForm,
            // },
        ];
        const menuItems = ref(forms.map((form) => ({
            label: form.label,
            command: () => emitter.emit('open-form-panel2', {
                label: form.label,
                component: form.component,
            }),
        })));
        menuItems.value = menuItems.value.concat([
            {
                label: () => trans('panels.FertilizationForm.create_title'),
                command: () => emitter.emit('open-fertilization-form'),
            },
            {
                label: () => trans('panels.IrrigationForm.create_title'),
                command: () => emitter.emit('open-irrigation-form'),
            },
            {
                label: () => trans('panels.IrrigationWaterDataForm.create_title'),
                command: () => emitter.emit('open-irrigation-water-data-form'),
            },
            {
                label: () => trans('panels.SoilDataForm.create_title'),
                command: () => emitter.emit('open-soil-data-form'),
            },
            {
                label: () => trans('panels.LeavesDataForm.create_title'),
                command: () => emitter.emit('open-leaves-data-form'),
            },
            {
                label: () => trans('panels.SymptomRecordForm.create_title'),
                command: () => emitter.emit('open-symptom-record-form'),
            },
        ]);
        const sidebarVisible = ref(false);
        watchEffect(() => (sidebarVisible.value = selectedForm.value !== undefined));
        const onSidebarHide = () => {
            setTimeout(() => (selectedForm.value = undefined), 200);
        };
        const __returned__ = { UserForm, OrchardForm, DevicesForm, FertilizationsForm, IrrigationsForm, PlotForm, emitter, pageProps, company, menu, selectedForm, forms, menuItems, sidebarVisible, onSidebarHide, get Menu() { return Menu; }, get Button() { return Button; }, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
